"use client"

import { createContext, useContext, useEffect } from "react"

import { useScreenPainted, useScreenVisible } from "@/platform/app-mode/use-screen-visible"
import { isEnvelopeHostAvailable } from "@/platform/bridge/use-native-bridge"

const WebViewContext = createContext<boolean | null>(null)

export const WebViewProvider = ({ isWebView, children }: { isWebView: boolean; children: React.ReactNode }) => {
  const visible = useScreenVisible()
  const painted = useScreenPainted()
  const hidden = isEnvelopeHostAvailable() && !visible
  useEffect(() => {
    if (visible) document.documentElement.removeAttribute("data-hosted-pending")
  }, [visible])
  return (
    <WebViewContext.Provider value={isWebView}>
      <div inert={hidden} aria-hidden={hidden || undefined} style={isEnvelopeHostAvailable() && !painted ? { visibility: "hidden" } : undefined}>
        {children}
      </div>
    </WebViewContext.Provider>
  )
}

export const useIsWebView = (): boolean => useContext(WebViewContext) ?? false
